import { Outlet, createFileRoute } from '@tanstack/react-router';

import CrumbContainer from '~/shared/CrumbContainer';

export const Route = createFileRoute('/_app/home/overview')({
	beforeLoad: () => ({
		getTitle: 'Overview'
	}),
	component: function OverviewLayout() {
		return <CrumbContainer container={<Outlet />} />;
	}
});
